import { render, staticRenderFns } from "./logo.vue?vue&type=template&id=041cf828"
import script from "./logo.vue?vue&type=script&lang=js"
export * from "./logo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.35_babel-core@7.0.0-bridge.0_@babel+core@7.29.7__cac_q4nveoxp7n4czahn54be2wnk2a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\new-site\\wetech-website-admin\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('041cf828')) {
      api.createRecord('041cf828', component.options)
    } else {
      api.reload('041cf828', component.options)
    }
    module.hot.accept("./logo.vue?vue&type=template&id=041cf828", function () {
      api.rerender('041cf828', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/components/sideBar/logo.vue"
export default component.exports